/**
 * Display name for a V2 conference. Inactive conferences carry an "(Inactive)" suffix
 * wherever they appear (APP-3936). Apply to labels only — never to values used as keys.
 */
export function conferenceDisplayName(
  name: string | null | undefined,
  status: string | null | undefined,
): string {
  if (!name) return '';
  return status === 'Inactive' ? `${name} (Inactive)` : name;
}
